import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from "google-maps-react";
import Select from "react-select";
import { gender } from "../config/data";
import InputField from "../components/UI/InputField";
import { getDateISOFormat, getPatientsubstring } from "../constants/globalLevelFunctions";
import Validation from "../actions/Validation";
import ReactDatatable from "@ashvin27/react-datatable";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import { CONFIG } from "../config/data";
import {
  getAllBusinessList,
  searchBusiness,
  getClientFamilyDetails,
  getDocByBusiness,
  getDocByBusinesswithspeciality,
  addCheckinURL,
  addQueue_modified,
  getTimeoutbycategory,
  createNotification,
  RazorPayPayment,
  getCredentials,
  updateclientqueuestatus,
  getpaymenttypeforbusiness,
  getdoctordetails,
  UpdateQueueRemove,
  CancelQueue,
  getServiceChargesbycategory
} from "../config/url.json";
import LogoSlider from './LogoSlider';
import SimpleSlider from './Simpleslider';

const mapStyles = {
  width: "100%",
  height: "115%",
};

function mapStateToProps(state) {
  return {
    appdata: state.AppData,
    userdata: state.AuthReducer.user,
    access_token: state.AuthReducer.access_token,
    searchData: state.SearchReducer.searchData,
    userdata: state.AuthReducer.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch({ type: "SET_LOGOUT" }),
    setSearchData: (data) => dispatch({ type: "SET_SEARCH_DATA", payload: data })
  };
}

class HospitalSearch extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = React.createRef();
    this.state = {
      timeout: {},
      isTimedOut: false,
      hospitals: [],
      showModal: false,
      visible: false,
      records: [],
      loading: false,
      business_list: [],
      business_name: "",
      latitude: "",
      longitude: "",
      bookModel: false,
      searchData: {
        business_name: props.searchData ? props.searchData.business_name : "",
        doctor_name: props.searchData ? props.searchData.doctor_name : "",
        facility: props.searchData ? props.searchData.facility : "",
        speciality: props.searchData ? props.searchData.speciality : "",
        city: props.searchData ? props.searchData.city : "",
        gender: props.searchData ? props.searchData.gender : "",
        distance: props.searchData && props.searchData.distance !== "" ? props.searchData.distance : "25",
        reviews: props.searchData ? props.searchData.reviews : "",
        distance_type: props.searchData && props.searchData.distance !== "" ? props.searchData.distance_type : "KM",
      },
      searchresults: {
        data: [],
      },
      queuein_data: {
        n_client_id: "",
        n_business_id: "",
        n_business_user_id: "",
        n_schedule_day_id: "",
        n_savedtime: "",
        n_status: "",
        n_isActive: "",
        business_name: "",
        address: "",
        expected_wait_time: "",
        schedule_type: "",
        other_comments: "",
        payment_mode: "",
      },
      selectedPlace: { value: "", label: "" },
      doctor_list: [],
      selected_doc: { value: "", label: "" },
      doctor_appointment_detail_list: [],
      selected_doctor_appointment_detail_list: [],
      selected_doc_schedule_type: "",
      family_list: [],
      enableqin: false,
      listofClientForQueue: [],
      loggedInClient: { client_id: "", name: "", relationship: "" },
      error: "",
      openModal: false,
      errors: {
        doctor_name: "",
        other_comments: "",
        payment_type_error: ""
      },
      searchErrorMessage: "",
    };

    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  handleLogout(e) {
    this.setState({ showModal: false });
    e.preventDefault();
    localStorage.removeItem("token");
    this.props.logout();
    this.props.history.push("/");
  }

  _onAction(e) {
    console.log('user did something', e);
    this.setState({ isTimedOut: false });
  }

  _onActive(e) {
    console.log('user is active', e);
    this.setState({ isTimedOut: false });
  }

  _onIdle(e) {
    console.log('user is idle', e);
    let isTimedOut = this.state.isTimedOut;
    let timeout = this.state.timeout;
    console.log(timeout);
    console.log(isTimedOut);
    if (!isTimedOut) {
      this.setState({ showModal: true });
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
    if (isTimedOut) {
      localStorage.removeItem("token");
      this.props.logout();
      this.props.history.push("/");
    }
  }

  handleInput = (e) => {
    let data = this.state.searchData;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    data[name] = value;
    if (name === "doctor_name" || name === "city") {
      this.validateMaxLength(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ searchData: data });
  };

  validateMaxLength(name, value, max) {
    let data = this.state.searchData;
    let errors = this.state.errors;

    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      errors[name] = "";
      data[name] = value;
    }
    this.setState({ searchData: data, errors: errors });
  }

handleselectChange = (selectedOptions, e) => {
    let data = this.state.searchData;
    data[e.name] = selectedOptions;
    if (e.name === "business_name" && null != selectedOptions) {
      console.log(selectedOptions);
      data.latitude = selectedOptions.latitude;
      data.longitude = selectedOptions.longitude;
          this.searchBusiness();

    } else {
      data.latitude = this.state.latitude;
      data.longitude = this.state.longitude;
    }
    this.setState({ searchData: data });

    // this.searchBusiness();
  };
  handlespecialityselectChange = (selectedOptions, e) => {
    let data = this.state.searchData;
    data[e.name] = selectedOptions;
     data.latitude = this.state.latitude;
     data.longitude = this.state.longitude;
     this.setState({ searchData: data });
  
 };
  handleDistanceChange = (e) => {
    let data = this.state.searchData;
    data.distance = e.target.value;
    this.setState({ searchData: data });
  };

  
  searchBusiness = () => {
    console.log("param");

    
   
   let params = this.state.searchData;
    console.log(params.speciality);
    if((null===params.speciality || "" === params.speciality) && params.business_name == "")       
    {
      this.setState({searchErrorMessage:"Choose the Speciality field and Distance field to search.",});
      return;
    } 
    else 
    {
      this.setState({ searchErrorMessage: "", });
    }
     //  let params = this.state.searchData;
    console.log(params);
    let data = {
      category: params.category ? params.category.label : "",
      business_name: params.business_name ? params.business_name.label : "",
      doctor_name: params.doctor_name ? params.doctor_name : "",
      facility: params.facility ? params.facility.value : "",
      speciality: params.speciality ? params.speciality.value : "",
      city: params.city,
      gender: params.gender ? params.gender.value : "",
      distance: params.distance,
      //distance: "",
      reviews: params.reviews,
      latitude: params.latitude,
      longitude: params.longitude,
      // latitude: "",
      // longitude: "",
      distance_type: params.distance_type,
      // distance_type: "",
      visit_type: params.visit_type,
    };
  
    console.log(data);
    axios
      .post(searchBusiness, data, CONFIG)
      .then((searchresults) => {
        console.log("business list");

        if (searchresults.data.status === "1") {
          console.log(searchresults);
         
          this.setState({ searchresults: searchresults.data,latitude:searchresults.data.data[0].latitude,longitude:searchresults.data.data[0].longitude });
          let result = this.state.searchresults;
          if (result.data.length) {
            result.data.forEach((element, index) => {

              // console.log(element);
              /*      if (element.user_id !== "") {
                axios.defaults.headers.common[
                  "Authorization"
                ] = `Bearer ${this.props.access_token}`;
   
                axios
                  .get(queueBusinessURL + element.user_id)
                  .then((details) => {
                    console.log("got response for waittime");
                    element.wait_time = details.data.waitTime;
                  })
                  .catch((e) => {});
              }*/
              element.s_no = index+1;
              result.data[index] = element;
            });
            console.log(result);
            let records=result.data;
            console.log(result.data);
            window.setTimeout(() => {
              this.setState({ searchresults: result,records:records });
            }, 500);
          }
        } else {
          this.setState({ searchErrorMessage: searchresults.data.message +",”Try adjusting the distance limit.”"});
          this.setState({ 
            searchresults:{
              data: [],
            } 
          });
           window.setTimeout(() => {
            this.setState({
              error: "",
            });
          }, 5000);
        }
      })
      .catch((e) => {
        console.log("business list failed");
      });

      axios
      .post(searchBusiness, data, CONFIG)
      .then((searchresults) => {
          if (searchresults.data.status === "1") {
              const hospitals = searchresults.data.data.map(hospital => ({
                  name: hospital.business_name,
                  address: `${hospital.address1}, ${hospital.city}`,
                  waitTime: hospital.expected_wait_time,
              }));

              this.setState({
                  searchresults: searchresults.data,
                  latitude: hospitals[0].latitude,
                  longitude: hospitals[0].longitude,
                  hospitals, // Set the hospitals array
              });
          } else {
              // Handle error
          }
      })
      .catch((e) => {
          console.log("business list failed");
      });
  };
  displayInfo = () => {
    return this.state.searchresults
      ? this.state.searchresults.data.map((business, index) => {
        return (
          <InfoWindow
            marker={this.state.activeMarker}
            mapCenter={{
              lat: business.latitude,
              lng: business.longitude,
            }}
            visible={this.state.showingInfoWindow}
          >
            <div>
              <h1>{business.business_name}</h1>
            </div>
          </InfoWindow>
        );
      })
      : "";
  };

    displayMarkers = () => {
      let mapImage = require("../assets/images/map-pin.png")
      let iconMarker = new window.google.maps.MarkerImage(
        mapImage,
        null /* size is determined at runtime */,
        null /* origin is 0,0 */,
        null /* anchor is bottom center of the scaled image */,
        new window.google.maps.Size(100, 100)
      );
      return this.state.searchresults
        ? this.state.searchresults.data.map((business, index) => {
          //This need to replcae real waiting time from queue table
  
  
        
         let waitingtime = business.expected_wait_time
          //  console.log(waitingtime)
          // if (!before30min) {
          return (
            <Marker
              key={index}
              id={index}
              name={business.business_name}
              position={{
                lat: business.latitude,
                lng: business.longitude,
              }}
              label={{
                text: waitingtime,
                color: "black",
                fontSize: "20px",
              }}
              cursor="pointer"
              disableDefaultUI={true}
              icon={iconMarker}
              onClick={this.showFamilydetail.bind(this, business)}
            />
          );
          // }
  
        })
        : "";
    };
     

//   displayMarkers() {
//     // Implement logic to display markers on the map
//     return this.state.business_list.map((business, index) => (
//       <Marker
//         key={index}
//         position={{ lat: business.latitude, lng: business.longitude }}
//         onClick={() => this.setState({ selectedPlace: business, showingInfoWindow: true })}
//       />
//     ));
//   }
componentDidMount = () => {
    // Set the Authorization header for axios
    axios.defaults.headers.common["Authorization"] = `Bearer ${this.props.access_token}`;

    // Fetch the business list
    axios
      .get(getAllBusinessList, null, CONFIG)
      .then((list) => {
        console.log(list);
        let business = [];
        let userlist = list.data.data;

        // Map the userlist to the desired format
        userlist.forEach((element) => {
          business.push({ label: element.business_name, value: element.user_id });
        });

        // Update the state with the business list
        this.setState({ business_list: business });
      })
      .catch((error) => {
        console.log(error);
      });

      
};

  getmyLocation = () => {
    const location = window.navigator && window.navigator.geolocation

    if (location) {
      location.getCurrentPosition((position) => {
        console.log(position.coords);
        console.log("position.coords");
        this.setState({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        }, () => {
          this.getData();
        })
      }, (error) => {
        // this.setState({ latitude: '9.9261153', longitude: '78.1140983' },
        //   () => {
        //     this.getData();
        //   })

      }, { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 })
    }
    else {
      this.getData();
    }
  }
  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };
  onMarkerClick = (props, marker, e) => {
    console.log(props);
    console.log(marker);
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });
  };

  getData = () => {
    console.log(this.state.latitude);
    let searchData = this.state.searchData;
    searchData.latitude = this.state.latitude ? this.state.latitude.toString() : "";
    searchData.longitude = this.state.longitude ? this.state.longitude.toString() : "";
    this.setState({ searchData });
   // this.reviewChange(this.state.searchData.reviews);
  //  this.searchBusiness();
    console.log("Latitude is :", this.state.latitude);
    console.log("Longitude is :", this.state.longitude);

    let loggedInClient = {};
    loggedInClient.client_id = this.props.user.id;
    loggedInClient.name = this.props.user.first_name;
    loggedInClient.relationship = "Self";

    this.setState({ loggedInClient });
    // this.setState({ latitude: latitude, longitude: longitude });

    //To get the Family details
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;
    axios
      .post(getClientFamilyDetails, { client_id: this.props.user.id }, CONFIG)
      .then((client_family) => {
        let list = [];
        list.unshift(this.state.loggedInClient);
        this.setState({ family_list: list });

        let dataArr = client_family.data.data;

        let family_list = this.state.family_list;
        dataArr.forEach((element, index) => {
          let family_member = {};
          family_member.client_id = element.user_id;
          family_member.name = element.first_name + " " + element.last_name;
          family_member.relationship = element.relationship;

          family_list[index + 1] = family_member;
          this.setState({ family_list: family_list ,client_name:family_member.name});
        });
        this.setState({ enableqin: true });
      })
      .catch((e) => { });
  }
  getCenterValue = (mapProps, map) => {
    console.log(mapProps.center);
    let url = new URL(map.mapUrl);
    let ll = url.searchParams.get("ll");
    console.log(ll.split(","));

    console.log("param");
    let params = this.state.searchData;
    params.latitude = ll.split(",")[0];
    params.longitude = ll.split(",")[1];
    console.log(params);
    //console.log(params.latitude);
    //console.log(params.longitude);
    console.log(this.state.searchresults);
    //this.setState({searchData: params});

    let data = {
      category: params.category ? params.category.label : "",
      business_name: params.business_name ? params.business_name.label : "",
      doctor_name: params.doctor_name ? params.doctor_name : "",
      facility: params.facility ? params.facility.value : "",
      speciality: params.speciality ? params.speciality.value : "",
      city: params.city,
      gender: params.gender ? params.gender.value : "",
      distance: params.distance,
      reviews: params.reviews,
      latitude: ll.split(",")[0],
      longitude: ll.split(",")[1],
      distance_type: params.distance_type,
      visit_type: params.visit_type,
    };


    axios
      .post(searchBusiness, data, CONFIG)
      .then((searchresults) => {
        console.log("business list");

        if (searchresults.data.status === "1") {
          console.log(searchresults);
          // this.setState({ searchresults: searchresults.data });
          let result = this.state.searchresults;
          if (result.data.length) {
            result.data.forEach((element, index) => {
              result.data[index] = element;
            });
            window.setTimeout(() => {
              // this.setState({ searchresults: result });
            }, 500);
          }
        } else {
          this.setState({ error: searchresults.data.message });
          window.setTimeout(() => {
            this.setState({
              error: "",
            });
          }, 5000);
        }
      })
      .catch((e) => {
        console.log("business list failed");
      });




  };
  clearSearchData = () => {
      var searchData = this.state.searchData;
      let searchErrorMessage=this.state.searchErrorMessage;
      searchData.business_name = "";
      searchData.doctor_name = "";
      searchData.facility = "";
      searchData.speciality = "";
      searchData.gender = "";
      searchData.city = "";
      searchData.distance = 5;
      searchData.distance_type = "KM";
      this.props.setSearchData(searchData);
      this.setState({  searchErrorMessage:""  });
      this.setState({ searchData: searchData,
        searchresults:{
          data: [],
        } 
      });
      searchData.reviews = 0;
     // this.getData();
      this.getmyLocation();
    };

  render() {
    let {
        business_list,
        errors,
        searchData,
        searchresults,
        queuein_data,
        family_list,
        
  
      } = this.state;
    

    return (
      <Fragment>
      

<div className='map-location container-85 py-5 slide-left visible'>
  <Map
    className="mapclas"
    google={this.props.google}
    zoom={10}
    style={mapStyles}
    center={{
      lat: this.state.latitude,
      lng: this.state.longitude
    }}
    onDragend={this.getCenterValue}
  >
    {this.displayMarkers()}
    <InfoWindow
      marker={this.state.activeMarker}
      visible={this.state.showingInfoWindow}
    >
      <div>
        <h1>
          {this.state.selectedPlace ? this.state.selectedPlace.name : ""}
        </h1>
      </div>
    </InfoWindow>
  </Map>
</div>

<div className='filter-section slide-left visible'>
  <div className='container-85'>
    <div className='row'>
      <div className='col-md-5 mb-3 mt-4'>
        <div className='search-option'>
          <Select
            maxMenuHeight={120}
            className="form-control p-0"
            name="business_name"
            value={searchData.business_name}
            onChange={this.handleselectChange}
            options={business_list}
            isClearable={true}
            placeholder="Select Hospital" // Placeholder added here
            menuPortalTarget={document.body}
          />
        </div>
      </div>
      <div className='col-md-5 mb-3 mt-4'>
        <div className='search-option'>
          <InputField
            inputType={"text"}
            name={"city"}
            controlFunc={this.handleInput}
            content={searchData.city}
            placeholder="City" // Placeholder added here
            max={30}
          />
        </div>
      </div>
      <div className='search-option text-center lastbtn'>
        <button className='btn-ghost btn_sec' onClick={this.searchBusiness}>Search</button>
      </div>
    </div>
  </div>
</div>

<hr />

<div className='logo-slider container-90 slide-right visible'>
  <LogoSlider />
</div>

<div className='profile-section ps-lg-5 ps-0'>
  <SimpleSlider hospitals={this.state.hospitals} />
</div>

      </Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  GoogleApiWrapper({
    apiKey: "AIzaSyC4pBKGj8xlAtXpfpV5jhVa7NbMt_8Yb4g",
  })(HospitalSearch)
);